import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.25 12.0001C2.25 6.61526 6.61526 2.25 12.0001 2.25C17.3849 2.25 21.7502 6.61526 21.7502 12.0001C21.7502 17.3849 17.3849 21.7502 12.0001 21.7502C6.61526 21.7502 2.25 17.3849 2.25 12.0001ZM12.7683 8.97877C13.532 8.97877 14.1511 8.35966 14.1511 7.59595C14.1511 6.83224 13.532 6.21313 12.7683 6.21313C12.0046 6.21313 11.3855 6.83224 11.3855 7.59595C11.3855 8.35966 12.0046 8.97877 12.7683 8.97877ZM10.1761 10.3844L12.518 10.1446C12.7652 10.1193 12.8888 10.1066 12.9801 10.1295C13.2005 10.1849 13.362 10.3735 13.3827 10.5998C13.3912 10.6935 13.3597 10.8137 13.2965 11.054L12.1058 15.5869C11.9906 16.0255 12.2479 16.4781 12.869 16.0018L13.5204 15.4207C13.7593 15.2005 14.1248 15.4778 13.9771 15.7672C13.2733 16.9912 12.7825 17.3794 11.991 17.6213C11.7615 17.6914 11.281 17.6989 11.0414 17.6854C10.2486 17.6406 9.69193 16.8862 9.88296 16.1155L11.1004 11.2042C11.1369 11.0569 11.017 10.9177 10.8659 10.9321L10.236 10.9919C10.0569 11.0089 9.90196 10.868 9.90196 10.688C9.90196 10.5315 10.0204 10.4004 10.1761 10.3844Z"
        fill={colorValue}
      />
    </svg>
  );
};
